/*
 _______________________________________________________
/ This code was generated by a tool.                    \
|                                                       |
| Changes to this file may cause incorrect behavior and |
\  will be lost if the code is regenerated.             /
 -------------------------------------------------------
       \   ,__,
        \  (oo)____
           (__)    )\
              ||--|| *
*/
enum OralDietExecuteTimeModalAliases {
  ADMINISTRATION_BY_PROCESS_CARD = 'administration-by-process-card',
  DIET_DESCRIPTION_FIELD = 'diet-description-field',
  DIET_DESCRIPTION_PANEL = 'diet-description-panel',
  DIET_DESCRIPTION_TEXT = 'diet-description-text',
  DIET_HOUR_FIELD = 'diet-hour-field',
  DIET_HOUR_TEXT = 'diet-hour-text',
  DIET_JUSTIFICATION_FIELD = 'diet-justification-field',
  DIET_JUSTIFICATION_FORM = 'diet-justification-form',
  DIET_JUSTIFICATION_PANEL = 'diet-justification-panel',
  DIET_NAME_PANEL = 'diet-name-panel',
  DIET_OBSERVATION_FIELD = 'diet-observation-field',
  DIET_OBSERVATION_PANEL = 'diet-observation-panel',
  EXECUTE_BUTTON = 'execute-button',
  EXECUTE_TIME_BAR_CODE = 'execute-time-bar-code',
  EXECUTE_TIME_BAR_CODE_PANEL = 'execute-time-bar-code-panel',
  FOOTER_LEGENDS = 'footer-legends',
  FOOTER_PANEL = 'footer-panel',
  GLOBAL_ACTIONS = 'global-actions',
  JUSTIFICATION_TEXT_AREA = 'justification-text-area',
  OBSERVATION_TEXT = 'observation-text',
  ORAL_DIET_DESCRIPTION_DECK = 'oral-diet-description-deck',
  ORAL_DIET_EXECUTE_TIME_LAYOUT = 'oral-diet-execute-time-layout',
}
export { OralDietExecuteTimeModalAliases };
